// extracted by mini-css-extract-plugin
module.exports = {"container":"UnitScreen_container__3aKag","tabs":"UnitScreen_tabs__391fg","tab":"UnitScreen_tab__2hiNY"};